export const addClass = (fullClassName = "", newClassName: string) => {
    const className = fullClassName.replace(newClassName, "") + " " + newClassName
    return className.trim()
  }
  
  export const removeClass = (fullClassName = "", newClassName: string) => {
    return fullClassName.replace(newClassName, "").trim()
  }
  
  export const resetClassNames = () => "rct-node rct-node-leaf"
  
  export const Class = {
    addClass,
    removeClass,
    resetClassNames,
  }
  